export function teamBio() {
  return {
    isOpen: false,
    selectedMember: null,

    openBio(member) {
      this.selectedMember = member;
      this.isOpen = true;
      // Focus trap and scroll prevention will be handled by Alpine's x-trap directive
    },

    closeBio() {
      this.isOpen = false;
      this.selectedMember = null;
    },

    // Handle escape key and backdrop click
    handleKeydown(event) {
      if (event.key === 'Escape') {
        this.closeBio();
      }
    }
  };
}